'use client';

import dynamic from 'next/dynamic';

// The developer console reads/writes IndexedDB, which only exists in the
// browser. Loading it with ssr:false keeps server-rendered markup stable and
// avoids any IndexedDB access during SSR/hydration.
const DeveloperConsole = dynamic(() => import('./developerconsole'), {
  ssr: false,
  loading: () => (
    <div
      role="status"
      aria-live="polite"
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#b8b8b8',
      }}
    >
      Loading developer console…
    </div>
  ),
});

export default function DeveloperPage() {
  return <DeveloperConsole />;
}
